import { atom, selectorFamily } from 'recoil';
import { AgreementsService } from 'api';
export const getAgreementsRequestIdState = atom({
  key: 'getAgreementsRequestIdState',
  default: 0
});
const getAgreementsAndVehicle = selectorFamily({
  key: 'getAgreementsAndVehicle',
  get: customerId => async ({
    get
  }) => {
    if (!customerId) return [];
    get(getAgreementsRequestIdState);
    try {
      const agreementsAndVehicles = await AgreementsService.getAgreementsWithObEsAndVehiclesForCustomer({
        customerId,
        body: {}
      });
      return agreementsAndVehicles.results;
    } catch (e) {
      return [];
    }
  }
});
export default getAgreementsAndVehicle;